import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { OOPromoCode } from "src/app/shared/models/OOPromoCode.item";

@Component({
	selector: "app-promo-code-list-view",
	templateUrl: "./promo-code-list-view.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class PromoCodeListViewComponent implements OnInit, OnChanges {
	@Input() promoCodeSelected: OOPromoCode;
	@Output() promoCodeSelectedChange = new EventEmitter<OOPromoCode>();

	constructor(public app: AppService, private focuslink: FocuslinkService, public venueSvc: OOVenueService) {}

	ngOnInit(): void {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.promoCodeSelected && !changes.promoCodeSelected.previousValue?.sk) {
			this.venueSvc.ooPromoCodes?.forEach((promoCode, idx) => {
				if (!promoCode.sk) {
					this.venueSvc.ooPromoCodes.splice(idx, 1);
				}
			});
		}
	}

	onCreateNew() {
		this.venueSvc.ooPromoCodes.push(
			new OOPromoCode({
				pk: this.venueSvc.venueKey.toString(),
			})
		);
		this.promoCodeSelected = this.venueSvc.ooPromoCodes[this.venueSvc.ooPromoCodes.length - 1];
		this.promoCodeSelectedChange.emit(this.promoCodeSelected);
	}
}
